// Libraries
var Ably = require('ably');

class Realtime {

    constructor() {
        this.client = null;
    }

    subscribe = (channelId, realtimeKey, callback) => {
        if(this.client === null) {
            // as each module passes in the same realtimeKey, only use the first one received
            this.client = new Ably.Realtime(realtimeKey);
        }

        var channel = this.client.channels.get(channelId);      

        channel.subscribe(function (message) {
            console.debug('Message received from: ' + message.name);
            callback(message);
        });

        channel.on('detached', function () {
            console.debug('A channel was detached on channel: ' + channel.name);
            // reconnect to the channel if unexpectedly disconnected
            if (this.client.connection.state === 'connected') {
                channel.attach();
                console.debug('A channel was re-attached: ' + channel.name);
            }
        });

        this.client.connection.on('connected', function () {
            channel.attach();
            console.log('Module subscribed to channel: ' + channel.name);
        });

    }
}

// export as a singleton to have one Ably client connection shared between all modules
module.exports = new Realtime();


// WEBPACK FOOTER //
// ./src/common/Realtime/Realtime.js